/**
 * ZIFEK — Insertion du texte issu de la dictée vocale (Whisper).
 *
 * Le texte transcrit est toujours inséré à la position du curseur (ou à la fin
 * du champ s'il n'y a pas de sélection), SANS effacer le contenu existant.
 * Aucun envoi automatique : l'utilisateur relit et corrige avant de valider.
 */

export type VoiceField = HTMLInputElement | HTMLTextAreaElement | null;

/**
 * Calcule la nouvelle valeur d'un champ après insertion du texte dicté.
 * @param el    le champ ciblé (pour lire la sélection / le curseur)
 * @param current valeur actuelle du champ
 * @param text  texte transcrit à insérer
 */
export function insertTranscriptAtCursor(el: VoiceField, current: string, text: string): string {
  const clean = text.trim();
  if (!clean) return current;
  if (!el) return current ? `${current} ${clean}` : clean;
  const start = el.selectionStart ?? current.length;
  const end = el.selectionEnd ?? current.length;
  const before = current.slice(0, start);
  const after = current.slice(end);
  const sep = before && !/\s$/.test(before) ? ' ' : '';
  return `${before}${sep}${clean}${after}`;
}